import { hasSlotContent as d } from "../../common/utils/index.js";
import { resolveComponent as h, openBlock as o, createElementBlock as n, createVNode as p, createSlots as l, withCtx as i, renderSlot as r, createCommentVNode as s } from "vue";
import { _ as a } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import u from "../chip/chip.js";
const f = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeGroupedChip",
  components: {
    DtChip: u
  },
  data() {
    return {
      hasSlotContent: d
    };
  }
}, _ = {
  "data-qa": "dt-recipe-grouped-chip",
  class: "d-recipe-grouped-chip"
}, g = {
  key: 0,
  "data-qa": "left-grouped-chip-icon"
}, m = {
  key: 0,
  "data-qa": "left-grouped-chip-content"
}, C = {
  key: 0,
  "data-qa": "right-grouped-chip-icon"
}, v = {
  key: 0,
  "data-qa": "right-grouped-chip-content"
};
function S(e, $, k, q, t, y) {
  const c = h("dt-chip");
  return o(), n("div", _, [
    p(c, {
      "hide-close": !0,
      interactive: !1,
      size: "xs",
      "grouped-chip": !0,
      class: "d-recipe-grouped-chip__content d-recipe-grouped-chip__content-left"
    }, l({
      default: i(() => [
        t.hasSlotContent(e.$slots.leftContent) ? (o(), n("div", m, [
          r(e.$slots, "leftContent")
        ])) : s("", !0)
      ]),
      _: 2
    }, [
      t.hasSlotContent(e.$slots.leftIcon) ? {
        name: "icon",
        fn: i(() => [
          t.hasSlotContent(e.$slots.leftIcon) ? (o(), n("div", g, [
            r(e.$slots, "leftIcon")
          ])) : s("", !0)
        ]),
        key: "0"
      } : void 0
    ]), 1024),
    p(c, {
      "hide-close": !0,
      interactive: !1,
      size: "xs",
      "grouped-chip": !0,
      class: "d-recipe-grouped-chip__content d-recipe-grouped-chip__content-right"
    }, {
      icon: i(() => [
        t.hasSlotContent(e.$slots.rightIcon) ? (o(), n("div", C, [
          r(e.$slots, "rightIcon")
        ])) : s("", !0)
      ]),
      default: i(() => [
        t.hasSlotContent(e.$slots.rightContent) ? (o(), n("div", v, [
          r(e.$slots, "rightContent")
        ])) : s("", !0)
      ]),
      _: 3
    })
  ]);
}
const E = /* @__PURE__ */ a(f, [["render", S]]);
export {
  E as default
};
//# sourceMappingURL=grouped-chip.js.map
